// @ts-nocheck
import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {Parcel} from '../../../../_models/_tracks-models'
import { DateRow } from '../../../core/_models/_parcels-models'

type Props = {
  column: ColumnInstance<Parcel | DateRow>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {CustomHeaderColumn}
